export const debitCardContentBox = {
    showLockAndUnlockNavigation: true,
    showDisplayPanNavigation: true,
    showChangeCardLimitsNavigation: true,
};
